import * as THREE from 'three';

export default function Text({ nodes }) {
  const shaderConfig = {
    uniforms: {},
    vertexShader: `
      varying vec2 vUv;
      void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }
    `,
    fragmentShader: `
      varying vec2 vUv;

      void main() {
        // Colore arancione soft con un po' più di intensità
        vec3 orange = vec3(0.75, 0.50, 0.18);
        
        gl_FragColor = vec4(orange, 1.0);
      }
    `
  };

  return (
    <group position-y={0.9}>
      {/* LANGIO - Bordo */}
      {nodes.LANGIO && (
        <mesh 
          geometry={nodes.LANGIO.geometry}
          position={nodes.LANGIO.position}
          rotation={nodes.LANGIO.rotation}
          scale={[nodes.LANGIO.scale[0] * 1.05, nodes.LANGIO.scale[1] * 1.05, nodes.LANGIO.scale[2] * 1.05]}
        >
          <meshStandardMaterial 
            color={0x2d1810}
            roughness={0.7}
          />
        </mesh>
      )}
      
      {/* LANGIO - Colore principale */}
      {nodes.LANGIO && (
        <mesh 
          geometry={nodes.LANGIO.geometry}
          position={nodes.LANGIO.position}
          rotation={nodes.LANGIO.rotation}
          scale={nodes.LANGIO.scale}
        >
          <shaderMaterial 
            uniforms={THREE.UniformsUtils.clone(shaderConfig.uniforms)}
            vertexShader={shaderConfig.vertexShader}
            fragmentShader={shaderConfig.fragmentShader}
            side={THREE.DoubleSide}
          />
        </mesh>
      )}
      
      {/* Testo - Bordo (potrebbe essere una delle scritte) */}
      {nodes.Testo && (
        <mesh 
          geometry={nodes.Testo.geometry}
          position={nodes.Testo.position}
          rotation={nodes.Testo.rotation}
          scale={[nodes.Testo.scale[0] * 1.05, nodes.Testo.scale[1] * 1.05, nodes.Testo.scale[2] * 1.05]}
        >
          <meshStandardMaterial 
            color={0x2d1810}
            roughness={0.7}
          />
        </mesh>
      )}
      
      {/* Testo - Colore principale */}
      {nodes.Testo && (
        <mesh 
          geometry={nodes.Testo.geometry}
          position={nodes.Testo.position}
          rotation={nodes.Testo.rotation}
          scale={nodes.Testo.scale}
        >
          <shaderMaterial 
            uniforms={THREE.UniformsUtils.clone(shaderConfig.uniforms)}
            vertexShader={shaderConfig.vertexShader}
            fragmentShader={shaderConfig.fragmentShader}
            side={THREE.DoubleSide}
          />
        </mesh>
      )}
      
      {/* Testo002 - Bordo (probabilmente HOUSE) */}
      {nodes.Testo002 && (
        <mesh 
          geometry={nodes.Testo002.geometry}
          position={nodes.Testo002.position}
          rotation={nodes.Testo002.rotation}
          scale={[nodes.Testo002.scale[0] * 1.05, nodes.Testo002.scale[1] * 1.05, nodes.Testo002.scale[2] * 1.05]}
        >
          <meshStandardMaterial 
            color={0x2d1810}
            roughness={0.7}
          />
        </mesh>
      )}
      
      {/* Testo002 - Colore principale */}
      {nodes.Testo002 && (
        <mesh 
          geometry={nodes.Testo002.geometry}
          position={nodes.Testo002.position}
          rotation={nodes.Testo002.rotation}
          scale={nodes.Testo002.scale}
        >
          <shaderMaterial 
            uniforms={THREE.UniformsUtils.clone(shaderConfig.uniforms)}
            vertexShader={shaderConfig.vertexShader}
            fragmentShader={shaderConfig.fragmentShader}
            side={THREE.DoubleSide}
          />
        </mesh>
      )}
    </group>
  )
}
